import useTheme from "@mui/material/styles/useTheme";

import {PAGE_MENU_DRAWER_WIDTH, FOOTER_HEIGHT} from "base/config/measurements";

import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Typography from "@mui/material/Typography";
import {Fragment} from "react";
import Grid from "@mui/material/Grid";

const Footer = ({
    left = [],
    text = "",
    links = [],
    fontFamily = "",
    position = "relative",
}) => {
    const theme = useTheme();

    const listItemStyle = {
        width: "fit-content",
        fontFamily: fontFamily || "inherit",
        p: 0,
        pt: "14px",
        [theme.breakpoints.up("md")]: {
            p: 0,
            "&:not(:last-child):after": {
                content: '" | "',
                px: "1rem",
                color: "white",
            },
        },
    };

    const footerLinks = links.map((link, index) => (
        <ListItem key={index} sx={listItemStyle}>
            {link}
        </ListItem>
    ));

    return (
        <Paper
            component="footer"
            sx={{
                position: {position},
                right: 0,
                bottom: 0,
                left: 0,
                m: 0,
                px: "1rem",
                zIndex: theme.zIndex.drawer + 1,
                borderRadius: 0,
                bgcolor: "primary.main",
            }}
            elevation={3}
        >
            <Grid
                container
                direction={{xs: "column", md: "row"}}
                height={{xs: "fit-content", md: `${FOOTER_HEIGHT}px`}}
            >
                <Grid item xs={6}>
                    <Typography
                        component="span"
                        sx={{
                            color: "white",
                            fontFamily: fontFamily || "inherit",
                            fontSize: "14px",
                            m: 0,
                            p: 0,
                        }}
                    >
                        {text}
                    </Typography>

                    {links.length !== 0 ? (
                        <List
                            sx={{
                                display: "flex",
                                flexDirection: {xs: "column", md: "row"},
                                width: "100%",
                                p: 0,
                            }}
                        >
                            {footerLinks}
                        </List>
                    ) : null}
                </Grid>
                <Grid
                    item
                    container
                    justifyContent="flex-end"
                    alignItems="flex-end"
                    spacing={1}
                    xs={6}
                >
                    {left.map((component, index) => (
                        <Grid item key={index}>
                            {component}
                        </Grid>
                    ))}
                </Grid>
            </Grid>
        </Paper>
    );
};

export default Footer;
